import { useState } from 'react';
import { VRSTE_DOKUMENATA, prikazVelicine } from '../lib/dokumenti';
import Ikona from './Ikona';
export default function PopisDokumenata({
  dokumenti,
  kucanstva,
  korisnikId,
  jeUprava,
  naPreuzmi,
  naArhiviraj,
  ucitava,
  greska,
  naOsvjezi,
}) {
  const [radi, postaviRadi] = useState(null);
  const [poruka, postaviPoruku] = useState('');
  const [potvrda, postaviPotvrdu] = useState(null);
  const radnja = async (d, arhiva = false) => {
    postaviRadi(d.id);
    postaviPoruku('');
    try {
      if (arhiva) {
        await naArhiviraj(d.id, !d.arhivirano);
        postaviPotvrdu(null);
        await naOsvjezi();
      } else {
        const url = await naPreuzmi(d);
        const veza = document.createElement('a');
        veza.href = url;
        veza.rel = 'noopener noreferrer';
        veza.download = d.izvorni_naziv;
        veza.click();
      }
    } catch (e) {
      postaviPoruku(e.message);
    } finally {
      postaviRadi(null);
    }
  };
  return (
    <div className="popis-dokumenata">
      {poruka && (
        <p className="poruka greska" role="alert">
          {poruka}
        </p>
      )}
      {greska && (
        <p className="obavijest greska" role="alert">
          {greska}{' '}
          <button className="tekst-gumb" onClick={naOsvjezi}>
            Pokušaj ponovno
          </button>
        </p>
      )}
      {ucitava ? (
        <p role="status">Učitavam dokumente…</p>
      ) : !greska && !dokumenti.length ? (
        <div className="prazni-dokumenti">
          <Ikona naziv="dokument" velicina={32} />
          <h3>Nema dokumenata za ovaj prikaz</h3>
          <p>Priloži dokument ili promijeni filtre.</p>
        </div>
      ) : (
        dokumenti.map((d) => (
          <article key={d.id} className="redak-dokumenta">
            <span className="ikona-ploha tirkiz">
              <Ikona
                naziv={d.vrsta === 'gdpr_privola' ? 'lokot' : 'dokument'}
              />
            </span>
            <div className="opis-dokumenta">
              <strong>{d.naziv}</strong>
              <span>
                {VRSTE_DOKUMENATA[d.vrsta]} ·{' '}
                {kucanstva.find((k) => k.id === d.kucanstvo_id)?.adresa ||
                  (d.kucanstvo_id ? 'Kućanstvo' : 'Opći dokument')}
              </span>
              <small>
                {d.izvorni_naziv} · {prikazVelicine(d.velicina)} ·{' '}
                {new Date(d.created_at).toLocaleDateString('hr-HR')}
                {d.datum_privole &&
                  ` · potpisano ${new Date(d.datum_privole + 'T12:00:00').toLocaleDateString('hr-HR')}`}
              </small>
              {d.stanje !== 'spremno' && (
                <span className="oznaka-pregleda">
                  Slanje nije dovršeno — ponovno odaberi datoteku za novi
                  pokušaj.
                </span>
              )}
              {d.arhivirano && (
                <span className="oznaka-pregleda">Arhivirano</span>
              )}
            </div>
            <div className="radnje-dokumenta">
              {d.stanje === 'spremno' && (
                <button
                  className="gumb sek"
                  disabled={radi === d.id}
                  onClick={() => radnja(d)}
                >
                  Preuzmi
                </button>
              )}
              {(jeUprava || d.unio === korisnikId) &&
                naArhiviraj &&
                (potvrda === d.id ? (
                  <div className="potvrda-arhive">
                    <span>
                      Arhiviraj ovaj prilog? Datoteka ostaje sačuvana.
                    </span>
                    <button
                      className="tekst-gumb"
                      disabled={!!radi}
                      onClick={() => radnja(d, true)}
                    >
                      Da, arhiviraj
                    </button>
                    <button
                      className="tekst-gumb"
                      onClick={() => postaviPotvrdu(null)}
                    >
                      Odustani
                    </button>
                  </div>
                ) : (
                  <button
                    className="tekst-gumb"
                    disabled={!!radi}
                    onClick={() =>
                      d.arhivirano ? radnja(d, true) : postaviPotvrdu(d.id)
                    }
                  >
                    {d.arhivirano ? 'Vrati iz arhive' : 'Arhiviraj'}
                  </button>
                ))}
            </div>
          </article>
        ))
      )}
    </div>
  );
}
